export default __webpack_public_path__ + "static/media/saymee_qr.9cc6283c.png";